import GitInfo from 'react-git-info/macro'
import packageJson from '../package.json'

const gitInfo = GitInfo()

let confProp
if (process.env.REACT_APP_TARGET === 'production') {
  if (process.env.REACT_APP_SERVER === 'officemail') {
    confProp = {
      DEBUG: false,
      SERVER: {
        restLandigURL: 'https://api.officemail.io/v1',
        URL: 'https://api.officemail.io/graphql',
        restURL: 'https://api.officemail.io',
        chatURL: 'https://chat.rework.so',
        mailAdminURL: 'https://mailbox-api.officemail.io/api/v1',
        wsAddress: 'chat-websocket.rework.so',
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  } else if (process.env.REACT_APP_SERVER === 'officemail-tokyo-prod') {
    confProp = {
      DEBUG: false,
      SERVER: {
        restLandigURL: 'https://api.officemail.jp/v1',
        URL: 'https://api.officemail.jp/graphql',
        restURL: 'https://api.officemail.jp',
        chatURL: null,
        mailAdminURL: 'https://mailbox-api.officemail.jp/api/v1',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://dev-org.officenext.net',
    }
  } else {
    confProp = {
      DEBUG: false,
      SERVER: {
        restLandigURL: 'https://api.enterprise.rework.so/v1',
        // URL: 'https://api.enterprise.rework.so/__admin/graphql',  <--(@정호:CONSOLE에서 ENTERPRISE호출시 __admin아님)
        URL: 'https://api.enterprise.rework.so/graphql',
        restURL: 'https://api.enterprise.rework.so',
        chatURL: 'https://chat.rework.so',
        mailAdminURL: 'https://mailbox-api.officemail.io/api/v1',
        wsAddress: 'chat-websocket.rework.so',
        wsURL: null,
      },
      officeNextURL: '',
    }
  }
} else if (process.env.REACT_APP_TARGET === 'test') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev.api.enterprise.rework.so/v1',
      URL: 'https://dev.api.enterprise.rework.so/graphql',
      // restURL: 'http://localhost:4030',
      restURL: 'https://dev.api.enterprise.rework.so',
      chatURL: 'https://dev.chat.rework.so',
      mailAdminURL: 'https://mailbox-api.officemail.app/api/v1',
      wsAddress: 'dev.chat.rework.so',
      wsURL: null,
    },
    officeNextURL: '',
  }
} else if (process.env.REACT_APP_TARGET === 'test1') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev-api.officemail.io/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      restURL: 'https://dev-api.officemail.io',
      chatURL: 'https://dev.chat.rework.so',
      mailAdminURL: 'https://mailbox-api.officemail.app/api/v1',
      wsAddress: '192.168.50.100:8000',
      wsURL: null,
    },
    officeNextURL: 'https://dev-org.officenext.net',
  }
} else {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev-api.officemail.io/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      restURL: 'https://dev-api.officemail.io',
      chatURL: 'https://dev.chat.rework.so',
      mailAdminURL: 'https://mailbox-api.officemail.app/api/v1',
      wsAddress: '192.168.50.100:8000',
      wsURL: null,
    },
    officeNextURL: 'https://dev-org.officenext.net',
  }
}

confProp.defaultLocale = window.navigator.language || window.navigator.userLanguage || 'en-US' // 'ko-KR'

if (window.globalConfig != null) {
  if (window.globalConfig.restURL != null) {
    confProp.SERVER.restURL = window.globalConfig.restURL
  }
  if (window.globalConfig.URL != null) {
    confProp.SERVER.URL = window.globalConfig.URL
  }
  if (window.globalConfig.LOCALE != null) {
    confProp.defaultLocale = window.globalConfig.LOCALE
  }
}

confProp.gitInfo = gitInfo
confProp.packageInfo = packageJson

const conf = confProp

export default conf
